// src/data/menus.js
const generateId = () => Math.random().toString().substr(11);
const menus = [
  {
    id: 1,
    name: "system",
    title: "系统设置",
    children: [
      {
        id: generateId(),
        name: "version-permission",
        title: "版本权限",
        component: () => import('@/views/admins/system/version-permission/version-permission.vue')
      },
      {
        id: generateId(),
        name: "member-version",
        title: "用户版本",
        component: () => import('@/views/admins/system/member-version/member-version.vue')
      },
    ]
  },
  {
    id: 2,
    name: "operation",
    title: "运营管理",
    children: [
      {
        id: generateId(),
        name: "user-set",
        title: "运营员新增",
        component: () => import('@/views/admins/operation/user-set/user-set.vue')
      },
      {
        id: generateId(),
        name: "menu-permission",
        title: "运营员权限设置",
        component: () => import('@/views/admins/operation/menupermission/menupermission.vue')
      },
      {
        id: generateId(),
        name: "product-category",
        title: "样衣类别",
        component: () => import('@/views/admins/system/product-category/product-category'), show: 'show' //这个产样分类本来是放在系统设置模块的，后来经过沟通，还是放在运营管理模块，所以说路径不一样，这是需要注意的
      },
      {
        id: generateId(),
        name: "user-product-launch",
        title: "官方产样发布",
        component: () => import('@/views/admins/operation/user-product-launch/user-product-launch')
      },
      {
        id: generateId(),
        name: "member-category",
        title: "用户身份",
        component: () => import('@/views/admins/operation/member-category/member-category'), show: 'show'
      },
      {
        id: generateId(),
        name: "member-list",
        title: "注册用户/商家管理列表",
        component: () => import('@/views/admins/operation/member-list/member-list')
      },
      {
        id: generateId(),
        name: "product-audit-list",
        title: "商家样衣审核列表",
        component: () => import('@/views/admins/operation/product-audit-list/product-audit-list')
      },
      {
        id: generateId(),
        name: "member-main-product",
        title: "商家首页主营产品",
        component: () => import('@/views/admins/operation/member-main-product/member-main-product'), show: 'show'
      },
      {
        id: generateId(),
        name: "member-fabric-apply",
        title: "商家首页面料适用",
        component: () => import('@/views/admins/operation/member-fabric-apply/member-fabric-apply'), show: 'show'
      },
      {
        id: generateId(),
        name: "base-product",
        title: "官方面料信息",
        component: () => import('@/views/admins/operation/base-product/base-product')
      },
      {
        id: generateId(),
        name: "yyyhao-profile",
        title: "公司简介",
        component: () => import('@/views/admins/operation/yyyhao-profile/yyyhao-profile')
      },
      {
        id: generateId(),
        name: "product-list",
        title: "官方产样列表",
        component: () => import('@/views/admins/operation/product-list/product-list'),
        type: "list"
      },
      {
        id: generateId(),
        name: "base-product-list",
        title: "官方面料信息列表",
        component: () => import('@/views/admins/operation/base-product-list/base-product-list'),
        type: "list"
      },

    ]
  },

  // {
  //   id: 3,
  //   name: "member",
  //   title: "用户权限",
  //   children: [
  //     // {
  //     //   id: generateId(),
  //     //   name: "user-set", 
  //     //   title: "运营员新增",
  //     //   component: () => import('@/views/admins/operation/user-set/user-set.vue')
  //     // },

  //   ]
  // },
];

export default {
  getNav() {
    return menus;
  },
  getMenu(method) {
    const targetMenu = menus.find(i => i.name === method);
    return targetMenu?.children.map(i => ({
      ...i,
      auth: [{ delflag: true, name: "menu:view" }] // 仅兜底，实际以后端为准
    })) || [];
  }
};